<template>
    <div name="card-info" class="wrapper">
        <loading v-if="isLoading" />

        <card-error-modal 
            v-if="cardError !== ''"
            :error="cardError"
            @onClose="closeModal"
        />
        <div class="contain" v-else>
            <error-modal 
                v-if="error"
                :error="error"
                @onClose="closeModal"
            />
            <div class="button-header">
                <img @click="back" style="width: 22px; cursor: pointer;" src="../assets/arrow_back.png" />
            </div>
            <steps
                :isStepper="true" 
                :step=3 
                :isRare="isWithoutDelegation"
            />
            <div  class="input-area" v-if="!isCardRegistered">
                <text-label 
                    :text="'카드 번호'"
                    :isDefault="true"
                />
                <div class="card-input" ref="cardInput"  >
                    <input v-focus-input-card @focus="handleFocus" @focusout="handleFocusOut" class="input-small" type="text" maxlength="4" v-model="cardNumber1" placeholder="0000" inputmode="numeric" @input="moveToNext($event, 'cardNumber2')" @keydown="moveToPrev($event, null)" ref="cardNumber1"> -
                    <input v-focus-input-card @focus="handleFocus" @focusout="handleFocusOut" class="input-small" type="text" maxlength="4" v-model="cardNumber2" placeholder="0000" inputmode="numeric" @input="moveToNext($event, 'cardNumber3')" @keydown="moveToPrev($event, 'cardNumber1')" ref="cardNumber2"> -
                    <input v-focus-input-card @focus="handleFocus" @focusout="handleFocusOut" class="input-small" type="password" maxlength="4" v-model="cardNumber3" placeholder="0000" inputmode="numeric" @input="moveToNext($event, 'cardNumber4')" @keydown="moveToPrev($event, 'cardNumber2')" ref="cardNumber3"> -
                    <input v-focus-input-card @focus="handleFocus" @focusout="handleFocusOut" class="input-small" type="password" maxlength="4" v-model="cardNumber4" placeholder="0000" inputmode="numeric" @keydown="moveToPrev($event, 'cardNumber3')" ref="cardNumber4">
                </div>
                <div class="error-info-text">{{ cardNumberError }}</div>
                <div class="direction-row">
                    <div style="width:calc(50% - 4px)">
                        <text-label 
                            :text="'유효기간'"
                            :isDefault="true"
                        />
                        <input 
                            v-model="card_ex"
                            inputmode="numeric"
                            v-focus-background
                            placeholder="MM(월)/YY(연도)"
                            maxlength="4"
                            class="input-big"
                            ref="cardEx"
                        />
                        <div class="error-info-text">{{ cardExError }}</div>
                    </div>
                    
                    <div  style="width:calc(50% - 4px)">   
                        <text-label 
                            :text="'비밀번호 앞 2자리'"
                            :isDefault="true"
                            style="font-size: 0px;"
                        />
                        <input
                            type="password"
                            inputmode="numeric"
                            maxlength="2"
                            class="input-big"
                            v-focus-background
                            placeholder="**"
                            v-model="card_pw"
                            ref="cardPw"
                        />
                        <div class="error-info-text">{{ cardPwError }}</div>
                    </div>
                </div>        
                <text-label 
                    :text="'이름 (카드 소유자)'"
                    :isDefault="true"
                />
                <input 
                    type="text"
                    v-model="cardInfo.card_user_name"
                    class="input-big"
                    v-focus-background
                    placeholder="이름을 적어주세요"
                    ref="name"
                />            
                <div class="error-info-text">{{ nameError }}</div>
                <text-label 
                    :text="'생년월일(사업자번호)'"
                    :isDefault="true"
                />
                <input 
                    type="text"
                    inputmode="numeric"
                    maxlength="10"
                    v-model="birth"
                    class="input-big"
                    v-focus-background
                    placeholder="주민번호 앞 6자리 또는 사업자번호 10자리"
                    ref="birth"
                />
                <div class="error-info-text">{{ birthError }}</div>
      
            </div>
            <!-- <div class="registered_card_area" v-else>
                <span class="card_title">등록된 결제 카드 </span>
                <div class="card-box" style="margin-top: 16px;">
                    <span class="card_name_text">{{ status.registerd_card_info.card_name }}</span>
                    <span class="card_number_text" style="margin-top: 11px;">{{status.registerd_card_info.card_number}}</span>
                    
                </div>
                <div class="control-box" style="margin-top: 40px;">
                    <span class="info_bold_text">등록된 결제 카드가 있습니다!</span>
                    <span class="info_text">카드 변경이 필요한 경우 변경하기 버튼을 눌러주세요.</span>
                     
                </div>
                <bottom-button 
                    :text="'다음 단계'"
                    :color="'var(--Gray-100, #1E1E1E)'"
                    @onClick="nextStepWithoutChange"
                    style="margin-top: 8px;"
                />      
                <bottom-button 
                    :text="'카드 변경하기'"
                    :color="'#FFF'"
                    @onClick="cardChange"
                    style="margin-top: 8px;"
                /> 
            </div> -->
            <!-- agree area -->
            <div class="agree-area">
                <span class="agree-title">약관에 동의해 주세요<span class="red">*</span></span>
                <div class="agree-detail-box" style="margin-top: 16px">
                    <div class="row">
                        <check-box 
                            :checked="agreement_personal_info"
                            @onClick="() => {agreement_personal_info = !agreement_personal_info}"
                        />
                        <span @click="() => {agreement_personal_info = !agreement_personal_info}" class="agree-text"><span style="color: var(--point-color3, #FF000F)">(필수)</span> 개인정보 수집 및 이용 동의</span>
                    </div>
                    <img style="width: 20px;cursor: pointer;" @click="openPolicy(2)" src="../assets/detail.png" />
                </div>
                <div v-if="agreeError" class="error-info-text">이용약관에 동의해 주세요</div>
             </div>
            <div class="button-wrapper">                
                <bottom-button 
                    v-if="!isCardRegistered"
                    :text="'제출하기'"
                    :color="'#184FA1'"
                    @onClick="nextStep"
                />
            </div>
            <!-- footer -->
            <!-- <page-footer 
                :state="0"
            /> -->
        </div>
        
    </div>
</template>

<script>
import Steps from '@/components/molecules/Steps';
import BottomButton from '@/components/atoms/BottomButton';
import TextLabel from '@/components/atoms/TextLabel';
import {mapState} from 'vuex';
import focusBackground from '@/components/directives/focusBackground';
import focusInputCard from '@/components/directives/focusInputCard';
import Convert from '@/utilities/convert';
import Constant from '@/constant';
import PageFooter from '@/components/molecules/PageFooter';
import Loading from '@/components/molecules/Loading'
import ErrorModal from '@/components/modals/ErrorModal';
import CardErrorModal from '@/components/modals/CardErrorModal';
import cookies from '@/utilities/cookie.js';
import CheckBox from '@/components/atoms/CheckBox';

export default {
    name: 'cardInfo',
    computed: {
        ...mapState(['cardInfo', 'pre_delegation_info', 'draftProfile']),
        // 위임장을 쓰지 않는 유형 (2형 당뇨, 자가도뇨 카테터, 희귀난치성질환)
        isWithoutDelegation: function()
        {
            return this.draftProfile.diabetes_type === 'TYPE2'
                || this.draftProfile.diabetes_type === 'SELF_CATHETER'
                || this.draftProfile.diabetes_type === 'RARE_INTRACTABLE';
        }
    },
    components: {
        Steps,
        BottomButton,
        TextLabel,
        Loading,
        PageFooter,
        ErrorModal,
        CardErrorModal,
        CheckBox
    },
    directives: {
        focusBackground,
        focusInputCard
    },
    data: function()
    {
        return {
            cardNumber1: '',
            cardNumber2: '',
            cardNumber3: '',
            cardNumber4: '',
            card_ex: '',
            card_pw: '',
            birth: '',
            isLoading: false,
            error: null,
            cardError: '',
            isCardRegistered: false,
            isCardUpdateModal: false, 
            token: null,
            agreement_personal_info: false,
            agreeError: false,
            cardNumberError: '',
            cardExError: '',
            cardPwError: '',
            nameError: '',
            birthError: ''
        }
    },
    mounted: function()
    {
        ChannelIO('shutdown')
        this.topFunction();

        if(!this.pre_delegation_info.is_loading)
        {
            this.$router.push({path: '/'})
        }

        this.token = cookies.getLocalStorage("access_token");
        if(this.token === null || this.token === undefined || this.token === '')
        {
            this.token = cookies.deleteLocalStorage("access_token");
            this.$router.push({path: '/', query: {returnUrl: 'register'}})
        }
        else
        {           
            this.$store.commit(Constant.INITIALIZE_CARD_INFO)                
        }
    }, 
    methods: {
        openPolicy: function(index)
        {   
            if(index === 1)
            {
                window.open("https://policy.soldoc.co.kr/terms", '_blank')
            }
            else if(index === 2)
            {
                window.open("https://policy.soldoc.co.kr/privacy-consent/payment", '_blank')
            }
            else if(index === 3)
            {
                window.open("https://policy.soldoc.co.kr/use", '_blank')
            }
            else if(index === 4)
            {
                window.open("https://policy.soldoc.co.kr/marketing", '_blank')
            }
        },
        topFunction: function() {
            document.body.scrollTop = 0; // For Safari
            document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
        }, 
        handleFocus: function()
        {
            this.$refs['cardInput'].style.backgroundColor = "#FFFFFF"
            this.$refs['cardInput'].style.border = "1px solid #184FA1"
        },
        handleFocusOut: function()
        {
            this.$refs['cardInput'].style.backgroundColor = "#f5f7fa"
            this.$refs['cardInput'].style.border = "1px solid #ccc"
        },
        cardChange: function()
        {
            this.isCardUpdateModal = true;
        },
        closeCardUpdateModal: function()
        {
            this.isCardUpdateModal = false;
        },
        changeCardInfo: function()
        {
            // update and next
        },
        nextStep: function()
        {
            // 카드번호 각 자리별 자리수 확인, 숫자 확인
            // 유효기간
            if(this.cardNumber1.length != 4)
            {
                this.errorFocus('cardNumber1');
                this.cardNumberError = '카드번호를 입력해 주세요.';
                return;
            }
            if(this.cardNumber2.length != 4)
            {
                this.errorFocus('cardNumber2');
                this.cardNumberError = '카드번호를 입력해 주세요.';
                return;
            }
            if(this.cardNumber3.length != 4)
            {
                this.errorFocus('cardNumber3');
                this.cardNumberError = '카드번호를 입력해 주세요.';
                return;
            }
            if(this.cardNumber4.length < 3)
            {
                this.errorFocus('cardNumber4');
                this.cardNumberError = '카드번호를 입력해 주세요.';
                return;
            }

            this.cardInfo.card_number = this.cardNumber1 + this.cardNumber2 + this.cardNumber3 + this.cardNumber4;

            if(this.card_ex.length === 4)
            {
                this.cardInfo.card_ex_month = this.card_ex.substring(0, 2);
                this.cardInfo.card_ex_year = this.card_ex.substring(2, 4);
            }
            else 
            {
                this.errorFocus('cardEx');
                this.cardExError = '유효기간을 입력해 주세요. (예 MMYY)';
                return;
            }

            if(this.card_pw.length !== 2)
            {
                this.errorFocus('cardPw');
                this.cardPwError = '비밀번호 앞 2자를 입력 해주세요.';
                return;
            }
            if(this.cardInfo.card_user_name == '')
            {
                this.errorFocus('name');
                this.nameError = '이름을 입력해주세요. (한글 또는 영문만 가능)'
                return;
            }
            if(Convert.containsNumber(this.cardInfo.card_user_name))
            {
                this.errorFocus('name');
                this.nameError = '한글 또는 영문으로 입력해주세요.'
                return;
            }
            if(this.birth.length !== 6 && this.birth.length !== 10)
            {
                this.errorFocus('birth')
                this.birthError = '주민번호 앞 6자리 또는 사업자번호 10자리를 입력해주세요.';
                return;
            }

            if(this.birth.length === 6)
            {
                if(!Convert.isValidBirthdate(this.birth))
                {
                    this.errorFocus('birth')
                    this.birthError = '주민번호 앞 6자리 또는 사업자번호 10자리를 입력해주세요.';
                    return;
                }
            }


            if(!this.agreement_personal_info)
            {
                this.agreeError = true;
                return;
            }


            this.cardInfo.card_pw = this.card_pw;
            this.cardInfo.card_nick_name = this.cardInfo.card_user_name;
            this.cardInfo.card_user_birth = this.birth;
            this.isLoading = true;

            // save card 
            // save profile 

            this.$store.dispatch(Constant.SAVE_CARD, {profile_id: this.pre_delegation_info.profile_id, token: this.token})
                .then(() => {
                   
                    this.$store.dispatch(Constant.REGISTER_PROFILE, {profile_id: this.pre_delegation_info.profile_id, token: this.token})
                        .then(() => {   
                            this.$router.push({path:'/booking'})
                        })
                        .catch((err) => {
                            this.error = err.message;
                            this.isLoading = false;
                        })

       

                })
                .catch((error) => {
                    if(error.code.includes('PAYMENT'))
                    {
                        this.isLoading = false;
                        this.onCardError(error.message)
                    }
                    else
                    {
                        this.isLoading = false;
                        this.onError(error.message)
                    }
                    
                })
        },
        moveToNext: function(event, nextField) {
            if (event.target.value.length === 4) {
                this.$refs[nextField].focus();
            }
        },
        moveToPrev: function(event, prevField) {
            if (event.key === 'Backspace' && event.target.value.length === 0 && prevField) {
                this.$refs[prevField].focus();
            }
        },
        errorFocus: function(field)
        {
            this.$refs[field].style.border = '1px solid var(--Semantic-01_Red, #FF000F)';

            const offsetTop = this.$refs[field].offsetTop;
                window.scrollTo({
                    top: offsetTop - 50, // 50px 위로 조정
                    behavior: 'smooth'
            });
        },
        onError: function(error){
            this.error = error;
        },  
        onCardError: function(error)
        {
            this.cardError = error;
        },
        closeModal: function()
        {
            this.error = null;
            this.cardError = '';
        },
        back: function()
        {
            // 위임장 화면을 거치지 않은 유형은 환자 정보 화면으로 돌아간다
            if(this.isWithoutDelegation)
            {
                this.$router.push('/register')
            }
            else
            {
                this.$router.push('/contract')
            }
            
        }
    },
    watch: {
        cardNumber1: function(newValue)
        {
            this.cardNumber1 = newValue.replace(/[^0-9]/g, '');
            this.cardNumberError = '';
            if(this.cardNumber1.length === 4 || this.cardNumber1.length === 0)
            {
                // this.$refs['cardInput'].style.backgroundColor = "#f5f7fa"
                // this.$refs['cardInput'].style.border = "#f5f7fa"
            }
            else
            {
                this.$refs['cardInput'].style.backgroundColor = "#FFFFFF"
                this.$refs['cardInput'].style.border = "1px solid #184FA1"
            }   
        },
        cardNumber2: function(newValue)
        {
            this.cardNumber2 = newValue.replace(/[^0-9]/g, '');
            this.cardNumberError = '';
            if(this.cardNumber2.length === 4 || this.cardNumber2.length === 0)
            {
                // this.$refs['cardInput'].style.backgroundColor = "#f5f7fa"
                // this.$refs['cardInput'].style.border = "#f5f7fa"
            }
            else
            {
                this.$refs['cardInput'].style.backgroundColor = "#FFFFFF"
                this.$refs['cardInput'].style.border = "1px solid #184FA1"
            }   
        },
        cardNumber3: function(newValue)
        {
            this.cardNumber3 = newValue.replace(/[^0-9]/g, '');
            this.cardNumberError = '';
            if(this.cardNumber3.length === 4)
            {
                // this.$refs['cardInput'].style.backgroundColor = "#f5f7fa"
            }
            else
            {
                this.$refs['cardInput'].style.backgroundColor = "#FFFFFF"
                this.$refs['cardInput'].style.border = "1px solid #184FA1"
            }   
        },
        cardNumber4: function(newValue)
        {
            this.cardNumber4 = newValue.replace(/[^0-9]/g, '');
            this.cardNumberError = '';
            if(this.cardNumber4.length === 4)
            {
            }
            else
            {
                this.$refs['cardInput'].style.backgroundColor = "#FFFFFF"
                this.$refs['cardInput'].style.border = "1px solid #184FA1"
            }   
        },
        card_ex: function(newValue)
        {
            this.card_ex = newValue.replace(/[^0-9]/g, '');
            this.cardExError = '';
        },
        card_pw: function(newValue)
        {
            this.card_pw = newValue.replace(/[^0-9]/g, '');
            this.cardPwError = '';
        },
        birth: function(newValue)
        {
            this.birth = newValue.replace(/[^0-9]/g, '');
            this.birthError = '';
        },
        'cardInfo.card_user_name': function()
        {
            this.nameError = '';
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .contain {
        width: 100%;
    }
    .card-input {
        display: flex;
        align-items: center;
        border: 1px solid #ccc;
        border-radius: 8px;
        background-color: #f5f7fa;
        width: 100%;
        box-sizing: border-box;
    }
    @media (min-width: 600px) {
        .contain {
            width: 600px;
            
        }
        
    }


    .input-area {
        width: 100%;
        padding: 20px 16px 30px 16px;
        border-bottom: 8px solid var(--Gray-sub-color1, #F3F5F8);
        box-sizing: border-box;
    }

    .input-small {
        width: calc(25%);
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        background-color: rgba(255, 255, 255, 0);
        border: 0;
        outline: none;
        box-sizing: border-box;
        text-align: center;
    }
    .input-big {
        width: 100%;
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        box-sizing: border-box;
    }
    input::placeholder {
        color: var(--Gray-50, #A3AAB6);
    }

    .input-medium {
        width: calc(50% - 32px - 50px);
        height: 48px;
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        padding-left: 16px;
        padding-right: 16px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        border-radius: 6px;
        margin-right: 7px;
        box-sizing: border-box;
    }
    .direction-row {
        display: flex;
        justify-content: space-between;
        align-items: flex-start;
        width: 100%;
    }
    .button-wrapper {
        width: 100%;
        padding: 40px 16px 30px 16px;
        box-sizing: border-box;
    }
    .card-box {
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
        width: 100%;
        height: 103px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 20px;

    }
    .card_number_text {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
    }
    .card_name_text {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
    }
    .card_title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .registered_card_area {
        width: 100%;
        box-sizing: border-box;
        padding: 30px 16px;   
        padding-bottom: 0;
    }
    .control-box {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
    .info_text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 18px;
        letter-spacing: -0.42px;
    }
    .info_bold_text {
        color: #1E1E1E;
        text-align: center;
        font-family: Pretendard;
        font-size: 14px;
        font-style: normal;
        font-weight: 700;
        line-height: 18px; /* 128.571% */
        letter-spacing: -0.42px;
    }
    .button-header {
        width: 100%;
        height: 75px;
        display: flex;
        justify-content: flex-start;
        align-items: flex-start;
        padding: 20.32px 15.5px;
        box-sizing: border-box;
        background: var(--Gray-20, #F3F5F8);
    }
    /* agree */
    .agree-area {
        padding: 40px 16px 0 16px;
        width: 100%;
        box-sizing: border-box;
    }
    .agree-detail-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: calc(100%);
        box-sizing: border-box;
    }
    .agree-text {
        color: var(--Gray-60, #6B7684);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 20px;
        margin-left: 17px;
    }
    .row {
        display: flex;
    }
    .error-info-text {
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 122.222% */
        margin-top: 8px;
    }
    .agree-title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 600;
        line-height: 26px; /* 108.333% */
    }
    .red {
        color: var(--Semantic-01_Red, #FF000F);
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 400;
        line-height: 26px;
    }
</style>


// WEBPACK FOOTER //
// src/page/CardInfo.vue